import { Component, OnInit, Input, HostBinding, EventEmitter, Output } from '@angular/core';
import { BrowserGlobalRef } from '@app/shared/global-ref';

@Component({
  selector: 'ecp-related-catalog-frame-item',
  templateUrl: 'related-frame-item.component.html',
  styleUrls: ['./related-frame-item.component.scss'],
})
export class RelatedFrameItemComponent implements OnInit {
  @HostBinding('class.related-item') related_item_ = true;
  @Input() selectedFrameUpc: string;
  @Input() upc: string;
  @Input() title: string;
  @Input() name: string;
  @Input() image: string;
  @Input() desc1: string;
  @Input() desc2: string;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  constructor(private globalRef: BrowserGlobalRef) {}

  ngOnInit(): void {
    this.globalRef.nativeGlobal.dataLayer.push({
      event: 'product portfolio_displayed',
      description: this.title,
      name: this.name,
    });
  }

  /**
   * clickedItem
   * @description handle click event and emit it back to the main page
   */
  clickedItem(upc) {
    this.onClick.emit({
      upc: this.upc,
    });
  }
}
